import { CompanyDetailAndJobGroups } from '@types';
import { items } from './sidebar-items';

export const filterOutSidebarItems = (
  sidebarItems: typeof items,
  company: CompanyDetailAndJobGroups | undefined
) => {
  const result = { ...sidebarItems };
  if (!company?.company.offersEmployeeWork) {
    result.planning = result.planning.filter((item) => item.path !== 'management/workforce');
  }
  return result;
};
